import 'moment-timezone';

// eslint-disable-next-line global-require
const moment = require('moment');

moment.tz.setDefault('America/Sao_Paulo');

export { moment };
